import { Customer, Discount, Order, OrderApi } from './types';

const order: OrderApi = {
  addCustomer(customer: Customer): Promise<void> {
    if (this.orderApi === undefined) {
      throw new Error('SDK has not been initialized yet.');
    }

    return this.orderApi.addCustomer(customer);
  },

  getCustomer(): Promise<Customer> {
    if (this.orderApi === undefined) {
      throw new Error('SDK has not been initialized yet.');
    }

    return this.orderApi.getCustomer();
  },

  removeCustomer(): Promise<void> {
    if (this.orderApi === undefined) {
      throw new Error('SDK has not been initialized yet.');
    }

    return this.orderApi.removeCustomer();
  },

  addDiscount(discount: Discount): Promise<string> {
    if (this.orderApi === undefined) {
      throw new Error('SDK has not been initialized yet.');
    }

    return this.orderApi.addDiscount(discount);
  },

  removeDiscount(discountId: string): Promise<void> {
    if (this.orderApi === undefined) {
      throw new Error('SDK has not been initialized yet.');
    }

    return this.orderApi.removeDiscount(discountId);
  },

  retrieve(): Promise<Order> {
    if (this.orderApi === undefined) {
      throw new Error('SDK has not been initialized yet.');
    }

    return this.orderApi.retrieve();
  },
};

export { order };

export { DiscountScope, DiscountType } from './types';
export type {
  Address,
  Customer,
  CustomerLookupAttributes,
  Discount,
  Order,
  OrderApi,
  OrderLineItem,
  OrderLineItemAppliedDiscount,
  OrderLineItemDiscount,
  OrderServiceCharge,
  Tender,
} from './types';
export {
  AddCustomerRequest,
  AddCustomerResponse,
  AddCustomerError,
  RemoveCustomerRequest,
  RemoveCustomerResponse,
  RemoveCustomerError,
} from './actions';
